export default "__VITE_ASSET__CCBU_uZg__"